<template>
  <div class="modal-content">
    <div class="sim-card-modal__title">
      {{ getLocalization('Full statistic for phone') }}: <span>+{{ this.selectedPhoneNumber }}</span>
    </div>
    <div class="sim-card-modal__table">

      <base-table
          :columns="columns"
          :wrapperFiltersData="wrapperFiltersData"
          :addModalInputData="null"
          :add-modal-input-data="false"
          :use-green-pagination-simple="true"
          :rowsPerPageText="getLocalization('Rows per page')"
          :nextText="getLocalization('Next')"
          :prevText="getLocalization('Previous')"
          :table-title="null"
          :empty-state-text="getLocalization('No data for table')"
          :render-list-to-show="listToShowByPhone"
          :per-page-default="perPage"
          :use-green-pagination="true"
      >
        <template v-slot:base-table-row="props">
          <div v-if="props.column.field === 'country'" class="d-flex gap-2 align-items-center">
            <img :src="props.row['country_img_path']" class="table-td-image" alt="">
            {{ props.formattedRow[props.column.field] }}
          </div>
          <div v-else-if="props.column.field === 'service'" class="d-flex gap-2 align-items-center">
            <img :src="props.row['service_img_path']" class="table-td-image" alt="">
            {{ props.formattedRow[props.column.field] }}
          </div>
          <template v-else-if="props.column.field === 'is_banned'">
            <div v-if="props.formattedRow[props.column.field]" class="--tag --error">{{ getLocalization('No') }}</div>
            <div v-else class="--tag --success">{{ getLocalization('Yes') }}</div>
          </template>
          <template v-else-if="props.column.field === 'banned_to'">
            <timer :target-time="props.formattedRow[props.column.field]"></timer>
          </template>
<!--          <template v-else-if="props.column.field === 'force_ban'">-->
<!--            <div class="&#45;&#45;tag &#45;&#45;success"-->
<!--                 v-if="props.formattedRow['banned_to'] === null"-->
<!--                 @click="blockOrUnlockPhone(props.row,1)">-->
<!--              {{ getLocalization('Block') }}-->
<!--            </div>-->
<!--            <button class="btn btn-danger w-100 fx-center" v-else-if="props.row.available_to_unblock" @click="blockOrUnlockPhone(props.row,0)">-->
<!--              {{ getLocalization('Unblock') }}-->
<!--            </button>-->
<!--          </template>-->
          <template v-else>
            {{ props.formattedRow[props.column.field] }}
          </template>
        </template>
        <div slot="emptystate">
          {{ getLocalization('No data') }}
        </div>
        <template v-slot:base-table-pagination-green-simple="props">
          <div class="activation-history-all__pagination">
            <green-custom-pagination
                :total="props.total"
                :perPage="perPage"
                :pageChanged="props.pageChanged"
                :perPageChanged="props.pageChanged"
            ></green-custom-pagination>
          </div>
        </template>
      </base-table>
    </div>
  </div>
</template>
<script>
import BaseTable from "../../../components/table/baseTable.vue";
import BaseAdminMixin from "../../../admin/components/mixins/BaseAdminMixin";
import '../../../assets/css/good-table-new-design.scss';
import GreenCustomPagination from "../../../components/table/pagination/greenCustomPagination.vue";
import CustomPagination from "../../../components/table/pagination/customPagination.vue";

export default {
  name: "actualSimsStatistic",
  components: {
    CustomPagination,
    BaseTable,
    GreenCustomPagination
  },
  mixins: [
    BaseAdminMixin
  ],
  props: [
    'selectedPhoneNumber',
  ],
  data: function () {
    return {
      wrapperFiltersData: {
        title: "",
        filtersUrl: "/cabinet/partner/statisticbyphone/" + this.selectedPhoneNumber,
        filtersUrlMethod: "get",
        startWithRequest: true,
        showCollapseFilter: false,
        showResetFilterButton: false,
        sendFilterRequestAfterSelect: true,
        filtersItems: true,
        items: {}
      },
      tableTitle: '',
      columns: [
        {
          label: this.getLocalization('Service'),
          field: 'service',
          thClass: 'custom-th-class',
        },
        {
          label: this.getLocalization('Canceled'),
          field: 'canceled_count',
          sortable: false,
        },
        {
          label: this.getLocalization("Successfully"),
          field: 'success_count',
          sortable: false,
        },
        {
          label: this.getLocalization('Sum'),
          field: 'sum',
          sortable: false,
        },
        {
          label: this.getLocalization('Is free'),
          field: 'is_banned',
          sortable: false,
        },
        {
          label: this.getLocalization('Time to unlock'),
          field: 'banned_to',
          sortable: false,
        },
        // {
        //   label: this.getLocalization('Forced locking'),
        //   field: 'force_ban',
        //   sortable: false,
        // },
      ],
      paramsToAdd: {
        countryId: null,
        serviceId: null,
        userId: null,
      },
      perPage: 250
    };
  },
  methods: {
    listToShowByPhone(list) {
      let data = [];
      let now = new Date().getTime();
      for (let elem of list) {
        let banned_to = new Date(elem['banned_to']).getTime();
        data.push({
          id: elem['id'],
          country: elem['service_variation']['country']['title'],
          country_img_path: elem['service_variation']['country']['img_path'],
          service: elem['service_variation']['service']['title'],
          service_img_path: elem['service_variation']['service']['img_path'],
          service_variation_id: elem['service_variation']['id'],
          phone: elem['phone'],
          sum: Number(elem['sum']).toFixed(2),
          success_count: elem['success_count'],
          canceled_count: elem['canceled_count'],
          banned_to: elem['banned_to'],
          is_banned: elem['is_banned'] || banned_to > now,
          available_to_unblock: elem['available_to_unblock']
        });
      }
      return data;
    },
    async blockOrUnlockPhone(phone, lockOrUnlock) {
      let response = await this.sendRequest('/cabinet/partner/statisticbyphone/blockorunlockphone', 'post', {phone, lockOrUnlock})
      if (response['status'] == 'ok') {
        let data = response['data'];
        for (let phoneAggregate of this.$children[0].filteredList) {
          if (phoneAggregate['id'] == data['id']) {
            phoneAggregate.banned_to = data['banned_to'];
          }
        }
        if (lockOrUnlock == 1) {
          await this.alertMessage(this.getLocalization('Phone number successfully blocked'));
        } else if (lockOrUnlock == 0) {
          await this.alertMessage(this.getLocalization('Phone number successfully unblocked'));
        }
      }
    }
  },
}
</script>
<style>
.timer-watch {
  display: flex;
}
</style>
